import React from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
input {
  height: 36px;
  border-radius: 5px;
   ${(props) => (props.error ? "border: 1px solid red" : "")};
}

  label {
    color: ${(props) => (props.error ? "red" : "")};
  }
`;


const Input = ({
  name,
  value="",
  label,
  onChange,
  error,
  type = "text",
  search,
  onClick,
  placeholder = "",
  onKeyPress,
  onKeyDown,
  maxLength=500,
  disabled=false,
  chkhex=false,
  checked,
  validate =false,
  format="",
  className = "btn btn-primary",
}) => {

  function doFormat(x, pattern, mask) {
    var strippedValue = x.replace(/[^0-9]/g, "");
    var chars = strippedValue.split('');
    var count = 0;
  
    var formatted = '';
    for (var i=0; i<pattern.length; i++) {
      const c = pattern[i];
      if (chars[count]) {
        if (/\*/.test(c)) {
          formatted += chars[count];
          count++;
        } else {
          formatted += c;
        }
      } else if (mask) {
        if (mask.split('')[i])
          formatted += mask.split('')[i];
      }
    }
    return formatted;
  }
  
  
  return (
    <div className="from-group">

     
     <InputWrapper error={error}>
     { label && <label htmlFor={name}>{label} </label> }
 
      <div className="input-group1 ">  
        <input
          value={value}
          onChange={(e) => onChange(name, doFormat(e.target.value,format,'"(xxx)xxxxx-xxxx"'),validate,chkhex)}
          id={name}
          name={name}
          data-format={format}
        
          type={type}
          disabled ={disabled}
          checked={checked}
          maxLength = {maxLength}
          placeholder={placeholder}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          className="form-control"
        ></input>

     

      </div>

    

      </InputWrapper>
      </div>
  
    
 
    
  );
};



export default Input;
